import { render, staticRenderFns } from "./GetOrg.vue?vue&type=template&id=15fcb90c"
import script from "./GetOrg.vue?vue&type=script&lang=js"
export * from "./GetOrg.vue?vue&type=script&lang=js"
import style0 from "./GetOrg.vue?vue&type=style&index=0&id=15fcb90c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports